import { forwardRef, type ReactNode } from "react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

// eslint-disable-next-line react/display-name
const WrapExperienceTextTitle = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className="font-spaceGrotesk text-ellipsis whitespace-normal font-bold text-black"
        {...props}
      >
        {children}
      </div>
    );
  },
);

export default WrapExperienceTextTitle;
